var map = {
	".": "Q6u2",
	"./": "Q6u2",
	"./01_get_contracts": "Fui1",
	"./01_get_contracts.json": "Fui1",
	"./02_get_premiumIndex": "5uda",
	"./02_get_premiumIndex.json": "5uda",
	"./03_get_openInterest": "ewcP",
	"./03_get_openInterest.json": "ewcP",
	"./04_get_kline": "FuQd",
	"./04_get_kline.json": "FuQd",
	"./05_get_depth": "GbOE",
	"./05_get_depth.json": "GbOE",
	"./06_get_ticker": "6xac",
	"./06_get_ticker.json": "6xac",
	"./index": "Q6u2",
	"./index.js": "Q6u2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xwDQ";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/api/market ^.*$
// module id = xwDQ
// module chunks = 3